import { render, staticRenderFns } from "./airports.vue?vue&type=template&id=9d672056&scoped=true"
import script from "./airports.vue?vue&type=script&lang=js"
export * from "./airports.vue?vue&type=script&lang=js"
import style0 from "./airports.vue?vue&type=style&index=0&id=9d672056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d672056",
  null
  
)

export default component.exports